module.exports = __webpack_public_path__ + "static/media/DomainSearch.da88a522.jpg";